import { createTheme } from "@mui/material/styles";
import { ACCENT_DARK, EASE_OUT, INK } from "./brand";

const theme = createTheme({
  palette: {
    primary: {
      main: ACCENT_DARK,
      dark: "#45399e",
      light: "#8b7fea",
      contrastText: "#fff",
    },
    text: {
      primary: INK,
    },
  },
  typography: {
    fontFamily: "'Public Sans', sans-serif",
    button: {
      textTransform: "none",
      fontWeight: 700,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          transition: `transform 160ms ${EASE_OUT}, background-color 160ms ease, box-shadow 200ms ${EASE_OUT}, filter 200ms ${EASE_OUT}`,
          "&:active": {
            transform: "scale(0.97)",
          },
          "@media (prefers-reduced-motion: reduce)": {
            "&:active": { transform: "none" },
          },
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
    },
  },
});

export default theme;
